/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BranchRenewalHistoryResponseDto } from './branchRenewalHistoryResponseDto';
import { DistrictResponseDto } from './districtResponseDto';
import { FranchiseTierResponseDto } from './franchiseTierResponseDto';
import { ProvinceResponseDto } from './provinceResponseDto';
import { SubDistrictResponseDto } from './subDistrictResponseDto';

export interface BranchResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  branchName: string;
  registerDate: string;
  name: string;
  contractStartDate: string;
  contractEndDate: string;
  remark: string;
  imageUrl: string;
  address: string;
  province: ProvinceResponseDto;
  district: DistrictResponseDto;
  subDistrict: SubDistrictResponseDto;
  zipCode: string;
  email: string;
  type: BranchResponseDto.TypeEnum;
  isActive: boolean;
  franchiseTier: FranchiseTierResponseDto;
  latestRenewalStatus: BranchResponseDto.LatestRenewalStatusEnum;
  latestRenewalDetail: BranchRenewalHistoryResponseDto;
}
// tslint:disable-next-line:no-namespace
export namespace BranchResponseDto {
  export type TypeEnum = 'franchise' | 'wpn';
  export const TypeEnum = {
      Franchise: 'franchise' as TypeEnum,
      Wpn: 'wpn' as TypeEnum,
  };
  export type LatestRenewalStatusEnum = 'pending' | 'in_progress' | 'completed';
  export const LatestRenewalStatusEnum = {
      Pending: 'pending' as LatestRenewalStatusEnum,
      InProgress: 'in_progress' as LatestRenewalStatusEnum,
      Completed: 'completed' as LatestRenewalStatusEnum,
  };
}
